import { Component, PropTypes } from 'react';
import cx from 'classnames';
import styles from './styles.css';

export default class Intro extends Component {
	static propTypes = {
		theme: PropTypes.oneOf(['light', 'dark']).isRequired
	}

	render() {
		return (
			<div className={cx(styles.intro, `${styles.intro}--${this.props.theme}`)}>
				<div className={styles.copy}>
					How do you auction an algorithm? Or hang an Instagram portrait? Would Dali have loved VR? Four pioneering digital art gallerists discuss all this and more in a live group chat chaired by CNN Style’s guest editor Art Basel Global Director Marc Spiegler.
				</div>

				<div className={styles.disclaimer}>
					The following conversation, chaired by Marc Spiegler, took place before Art Basel 2016 between the founders of four leading art galleries: Pilar Corrias in London, Steven Sacks in New York, Leo Xu in Shanghai and Nadine Zeidler in Berlin. All words, views and emojis are their own.
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Intro/index.js
 **/